import { useMutation } from "@tanstack/react-query";
import { useState } from "react";
import { genIdempotencyKey } from "../../utils/genIdempotencyKey";
import { processDocument } from "../requests/processDocument";
const IDEMPOTENCY_DESCRIPTOR = "process-document";
const useProcessDocument = (config) => {
    const [idempotencyKey, setIdempotencyKey] = useState(genIdempotencyKey(IDEMPOTENCY_DESCRIPTOR));
    const mutation = useMutation({
        mutationFn: async ({ personId, documents, documentId, bucket, }) => {
            if (config === null) {
                throw new Error("no auth");
            }
            return processDocument({
                personId,
                documents,
                documentId,
                bucket,
                idempotencyKey,
                config,
            });
        },
        onSuccess: (response) => {
            // Handle successful document processing
            return response;
        },
        onSettled: () => {
            setIdempotencyKey(genIdempotencyKey(IDEMPOTENCY_DESCRIPTOR));
        },
    });
    return mutation;
};
export default useProcessDocument;
//# sourceMappingURL=useProcessDocument.js.map